import React from "react";
import { SvgIcon } from "@mui/material";

const ProcessorIcon = props => {
  return (
    <SvgIcon {...props} viewBox="0 0 88 88">
      <g id="Group_1172" data-name="Group 1172">
        <path
          id="Path_2437"
          data-name="Path 2437"
          d="M16,958.362a10.019,10.019,0,0,0-10,10v67.969a10.046,10.046,0,0,0,10,10.031H84a10.046,10.046,0,0,0,10-10.031V968.362a10.019,10.019,0,0,0-10-10Zm0,4H84a5.94,5.94,0,0,1,6,6v67.969a5.966,5.966,0,0,1-6,6.031H16a5.966,5.966,0,0,1-6-6.031V968.362A5.94,5.94,0,0,1,16,962.362Zm-1,5v70H85v-70H15Zm4,4H81v62H19Zm20,8v8.063a4.47,4.47,0,0,0-3.937,3.938H27v4h8v2H27v4h8v2H27v4h8v2H27v4h8.063A4.505,4.505,0,0,0,39,1017.3v8.063h4v-8h2v8h4v-8h2v8h4v-8h2v8h4V1017.3a4.47,4.47,0,0,0,3.938-3.937H73v-4H65v-2h8v-4H65v-2h8v-4H65v-2h8v-4H64.938A4.436,4.436,0,0,0,61,987.425v-8.062H57v8H55v-8H51v8H49v-8H45v8H43v-8Zm.5,12H60.531a.425.425,0,0,1,.469.469v21.031a.449.449,0,0,1-.469.5H39.5a.473.473,0,0,1-.5-.5V991.831A.449.449,0,0,1,39.5,991.362Zm5.5,6v10H55v-10Zm4,4h2v2H49Z"
          transform="translate(-6 -958.362)"
          fill="#3f51b5"
        />
      </g>
    </SvgIcon>
  );
};

export default ProcessorIcon;
